import React from 'react';
import { CalendarIcon } from '@heroicons/react/24/outline';

const TourItinerary = ({ itinerary }) => {
  // Debug the incoming itinerary data
  console.log('TourItinerary received:', itinerary);
  
  // Enhanced normalize function to handle both string and object formats
  const normalizeItinerary = (data) => {
    if (!data) return [];
    
    // If it's not an array, try to convert it
    if (!Array.isArray(data)) {
      // If it's an object with numeric keys, convert to array
      if (typeof data === 'object') {
        return Object.values(data);
      }
      return [];
    }
    
    // Process each item to ensure it's in the correct format
    return data.map((item, index) => {
      // If item is a string, convert it to an object with description
      if (typeof item === 'string') {
        return {
          day: index + 1,
          title: `Day ${index + 1}`,
          description: item
        };
      }
      // If item is already an object, ensure it has all required properties
      else if (typeof item === 'object' && item !== null) {
        return {
          day: item.day || index + 1,
          title: item.title || item.name || `Day ${index + 1}`,
          description: item.description || item.desc || item.content || ''
        };
      }
      // Fallback for any other case
      return {
        day: index + 1,
        title: `Day ${index + 1}`,
        description: 'No description available for this day.'
      };
    });
  };
  
  const normalizedItinerary = normalizeItinerary(itinerary);
  
  // Handle empty or undefined itinerary
  if (!normalizedItinerary || normalizedItinerary.length === 0) {
    return (
      <div className="p-6">
        <h3 className="text-xl font-bold mb-4">Tour Itinerary</h3>
        <p className="text-gray-600">No itinerary information available for this tour.</p>
      </div>
    );
  }

  return (
    <div className="p-6">
      <h3 className="text-xl font-bold mb-6">Tour Itinerary</h3>
      <div className="space-y-6 ml-2">
        {normalizedItinerary.map((day, index) => (
          <div key={index} className="relative pl-8 pb-8">
            {/* Timeline connector */}
            {index < normalizedItinerary.length - 1 && (
              <div className="absolute left-4 top-8 bottom-0 w-0.5 bg-gray-200"></div>
            )}
            
            {/* Day indicator */}
            <div className="absolute left-0 top-0 flex items-center justify-center w-8 h-8 rounded-full bg-primary text-white font-semibold">
              {day.day}
            </div>
            
            <div className="bg-gray-50 rounded-lg p-5">
              <div className="flex items-center mb-3">
                <CalendarIcon className="h-5 w-5 text-primary mr-2" />
                <h4 className="text-lg font-semibold">
                  {day.title}
                </h4>
              </div>
              <p className="text-gray-600">
                {day.description || 'No description available for this day.'}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TourItinerary;
